"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_COLUMNS = exports.BASE_ENRICHED_COLUMNS = exports.toApiColumn = exports.createColumnId = exports.parseColumnId = void 0;
const attributes_1 = require("../../constants/attributes");
const MEASURE_PREFIX = '[M]';
const ENRICHED_TEXT_PREFIX = '[T]';
const regex = /^(\[\w*\])?(.*)/;
const parseColumnId = (columnId) => {
    const match = columnId.match(regex);
    const prefix = match[1];
    const label = match[2];
    return {
        label,
        dataMeta: {
            isMeasure: prefix === MEASURE_PREFIX,
            isAIEnriched: prefix === ENRICHED_TEXT_PREFIX,
        },
    };
};
exports.parseColumnId = parseColumnId;
/**
 * [M]Size - units of measurement
 * [T]Color - text attributes
 * brand_color - original attributes from the catalog (without prefix)
 * */
const createColumnId = (id, { isMeasure, isAIEnriched } = {}) => {
    let prefix = isMeasure ? MEASURE_PREFIX : '';
    if (isAIEnriched) {
        prefix = ENRICHED_TEXT_PREFIX;
    }
    return `${prefix}${id}`;
};
exports.createColumnId = createColumnId;
const API_SCALAR_COLUMNS = new Set([
    attributes_1.CustomProductAttributes.Name,
    attributes_1.CustomProductAttributes.ExternalId,
    attributes_1.CustomProductAttributes.CreatedAt,
]);
/**
 * Converts UI column IDs to API export format.
 * Scalar columns (name, externalId, createdAt) remain as-is.
 * Labeled columns ([T]Color, brand_color, etc.) use L:<label> format.
 */
const toApiColumn = (columnId) => {
    if (API_SCALAR_COLUMNS.has(columnId))
        return columnId;
    const { label } = (0, exports.parseColumnId)(columnId);
    return `L:${label}`;
};
exports.toApiColumn = toApiColumn;
exports.BASE_ENRICHED_COLUMNS = [
    (0, exports.createColumnId)(attributes_1.PRODUCT_IMAGE_LABEL, { isAIEnriched: true }),
    (0, exports.createColumnId)(attributes_1.PRODUCT_PAGE_URL_LABEL, { isAIEnriched: true }),
];
exports.BASE_COLUMNS = [
    attributes_1.CustomProductAttributes.ExternalId,
    attributes_1.CustomProductAttributes.Name,
    ...exports.BASE_ENRICHED_COLUMNS,
];
